import type { ConceptDef } from '../types';

export const tactLetters: ConceptDef = {
  kind: 'supervisorScored',
  id: 'tact-letters',
  label: 'Expressive Letters',
  category: 'Expressive',
  description: 'Show a letter; learner names it. Supervisor scores.',
  config: {
    promptMode: 'TEXT',
    prompts: [
      { prompt: 'A' },
      { prompt: 'B' },
      { prompt: 'C' },
      { prompt: 'D' },
      { prompt: 'E' },
      { prompt: 'F' },
      { prompt: 'G' },
      { prompt: 'H' },
    ],
  },
};
